import React from "react";
import styled from "styled-components";
import { theme } from "../theme/semanticTheme";
import { Badge } from "../atoms";

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  background: ${theme.colors.backgroundAlt};
  border-radius: ${theme.borderRadius.md};
  border: 1px solid ${theme.colors.border};
`;

const Label = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.textMuted};
`;

const Value = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  color: ${theme.colors.text};
`;

/**
 * Molecule: DataRow – label + value (or Badge). Reusable in payment sections, tables.
 */
export default function DataRow({ label, value, variant }) {
  return (
    <Row>
      <Label>{label}</Label>
      {variant ? <Badge variant={variant}>{value ?? "–"}</Badge> : <Value>{value ?? "–"}</Value>}
    </Row>
  );
}
